import {
  Component,
  ElementRef,
  inject,
  OnInit,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AutentificacionService } from 'src/app/_services/autentificacion.service';
import { FocusService } from 'src/app/_helpers/focus.service';
import { ValidacionForm } from 'src/app/_helpers/validacion-form.service';
import { SnackBarService } from 'src/app/_helpers/snack-bar.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalNotificacionComponent } from 'src/app/admin/shared/modals/modal-notificacion/modal-notificacion.component';
import { Common } from 'devextreme-angular';
import { Subject, takeUntil } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { RolUsuario } from 'src/app/_models/_enums/rolUsuario.enum';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-inicio-factor',
  templateUrl: './inicio-factor.component.html',
  styleUrls: ['./inicio-factor.component.scss'],
})
export class InicioFactorComponent implements OnInit {
  @Output() VolverInicio = new EventEmitter<void>();
  @Input() correo!: string | null; //Input con el que recogemos el correo emitido desde el acceso del login
  @Input() clave!: string | null;
  stylingMode: Common.EditorStyle = 'outlined';
  labelMode: Common.LabelMode = 'floating';
  envioFactorForm!: FormGroup;
  //Inyección de servicios necesarios
  public validacionService = inject(ValidacionForm);
  public focusService = inject(FocusService);
  //Servicios para los modales de aviso:
  private snackBarService = inject(SnackBarService);
  private dialogRef = inject(MatDialog);
  private elementRef = inject(ElementRef);
  private responsive = inject(BreakpointObserver);
  private navCtrl = inject(NavController);

  esResolucionMovil = !this.responsive.isMatched(Breakpoints.WebLandscape);
  destroy$ = new Subject<void>();

  envioCodigoMail: boolean = false;

  constructor(private autentificacionService: AutentificacionService) {}

  //Al iniciar el componente se inicia el formulario
  ngOnInit() {
    this.initForm();

    this.responsive
      .observe([Breakpoints.WebLandscape])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result.matches) {
          this.esResolucionMovil = false;
        } else {
          this.esResolucionMovil = true;
        }
      });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.focusService.focusPrimerCampo(this.elementRef);
    }, 200);
  }

  initForm() {
    this.envioFactorForm = new FormGroup({
      //correo: new FormControl('', [Validators.required, Validators.email]),
      codigo: new FormControl('', [Validators.required]), //sin validacion al inicio
      //mantenerSesion: new FormControl(false, []),
    });
  }

  reenviarCodigo() {
    this.autentificacionService.enviarCodigoInicioFA(this.correo).subscribe({
      next: (response) => {
        this.snackBarService.showSuccess(
          'Se ha enviado un correo con el código de acceso.',
        );
      },
      error: (error) => {
        this.snackBarService.showError(error.error);
      },
    });
  }

  onSubmit() {
    this.validacionService.markFormGroupTouched(this.envioFactorForm);

    if (this.envioFactorForm.invalid) {
      return;
    }

    const codigoControl = this.envioFactorForm.get('codigo').value;

    this.autentificacionService
      .loginDobleFactor(this.correo, this.clave, codigoControl, true)
      .subscribe({
        next: (response) => {
          if (response) {
            this.envioFactorForm.reset();
            // Si el usuario es rol proveedor, redirige a la ficha de su proveedor, caso contrario al inicio
            if (response.rol === RolUsuario.Proveedor) {
              this.navCtrl.navigateRoot([
                `/proveedores/proveedor-ficha/${response.idProveedor}`,
              ]);
            } else {
              this.navCtrl.navigateRoot(['/']);
            }
          }
        },
        error: (error) => {
          this.envioFactorForm.controls['codigo'].setErrors({
            codigoIncorrecto: true,
          });
          this.snackBarService.showError(error.error);
        },
      });

    /*const correo = this.envioFactorForm.get('correo')?.value;

    if (!this.envioCodigoMail) {
      //Funcion para recibir el correo con el código
      this.autentificacionService.enviarCodigoInicioFA(correo).subscribe({
        next: (response) => {
          this.snackBarService.showSuccess(
            'Se ha enviado un correo con el código de acceso.',
          );
          this.envioCodigoMail = true;
        },
        error: (error) => {
          this.snackBarService.showError(error.error);
        },
      });
    } else {
      //Funcion para iniciar sesión en la aplicacion
      const codigoControl = this.envioFactorForm.get('codigo');
      const mantenerSesion =
        this.envioFactorForm.get('mantenerSesion')?.value ?? false;
      //Campo obligatorio para el login
      codigoControl?.setValidators([Validators.required]);
      codigoControl?.updateValueAndValidity();

      this.autentificacionService
        .loginDobleFactor(correo, codigoControl.value, true, mantenerSesion)
        .subscribe({
          next: (response) => {
            if (response) {
              this.envioFactorForm.reset();
              // Si el usuario es rol proveedor, redirige a la ficha de su proveedor, caso contrario al inicio
              if (response.rol === RolUsuario.Proveedor) {
                this.navCtrl.navigateRoot([
                  `/proveedores/proveedor-ficha/${response.idProveedor}`,
                ]);
              } else {
                this.navCtrl.navigateRoot(['/']);
              }
            }
          },
          error: (error) => {
            this.envioFactorForm.controls['codigo'].setErrors({
              credencialesInvalidas: true,
            });
            this.snackBarService.showError(error.error);
          },
        });
    }*/

    // //SOLO CUANDO NO HAYA ERRORES EN LA PETICION ANTERIOR
    //this.envioCodigoMail = true;
  }

  //Funcion que controla el estado del formulario segun el campo a validar
  getValidacionEstado(
    nombreCampo: string,
    formGroup: FormGroup,
  ): 'valid' | 'invalid' {
    const control = formGroup.get(nombreCampo);
    if (!control) return 'valid';
    if (control.errors && control.errors['serverError']) return 'invalid';
    return this.validacionService.getFieldValidationState(control) || 'invalid';
  }

  onVolverAtras() {
    this.VolverInicio.emit();
  }
}
